module.exports = __webpack_public_path__ + "static/media/rating-example.ac9f0b72.png";